<template>
    <div class="modal fade" id="appMgrPermissionAppEditModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="width: 880px">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            <template v-if="isMDMAppForUI">
                                <template v-if="bAddMode">
                                    「SKYSEA MDM」アプリを追加
                                </template>
                                <template v-else>
                                    編集
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="bAddMode">
                                    Google Playストアから選択して追加
                                </template>
                                <template v-else>
                                    編集
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div style="margin-bottom: 16px;">
                        <template v-if="isMDMAppForUI">
                            利用を許可するアプリケーションに、「SKYSEA MDM」アプリを登録します。<br />「自動アップデート種別」を設定してください。
                        </template>
                        <template v-else>
                            利用を許可するアプリケーションを登録してください。
                        </template>
                    </div>
                    <div class="main-setting-table">
                        <div class="main-category-text">
                            <span class="main-category-font" style="font-size:16px">対象アプリケーション</span>
                        </div>
                    </div>
                    <div class="setting-area">
                        <div class="setting-box" style="margin-top: 0px !important; ">
                            <span class="box-item-title-left" style="width: 160px">アプリケーション名：</span>
                            <div class="d-flex flex-column">
                                <MaskInput convertType="text"
                                           class="input-text-scv"
                                           v-model="basicInfo.appName"
                                           style="width: 560px"
                                           disabled />
                            </div>
                            <template v-if="bAddMode && !isMDMAppForUI">
                                <button type="button" class="btn-scv-bgcolor btn-setting-size" @click="onGooglePlayButton" style="margin-left: 8px; width : 90px">選択</button>
                            </template>
                        </div>
                        <div class="setting-box">
                            <span class="box-item-title-left" style="width: 160px">パッケージ名：</span>
                            <div class="d-flex flex-column">
                                <MaskInput convertType="text"
                                           class="input-text-scv"
                                           v-model="basicInfo.packageName"
                                           style="width: 560px"
                                           disabled />
                            </div>
                        </div>
                    </div>

                    <div class="main-setting-table">
                        <div class="main-category-text">
                            <div class="d-flex flex-row align-items-center" style="height:20px">
                                <span class="main-category-font" style="font-size:16px">アプリケーション設定</span>
                                <InformationManual :arMessage="[getInfoAppSeting()]"
                                                   style="margin-left: 4px; margin-right: 4px;" />
                            </div>
                        </div>
                    </div>

                    <div class="setting-area">
                        <div class="setting-box" style="margin-top: 0px !important; ">
                            <span class="box-item-title-left">
                                インストール種別：
                                <InformationManual :arMessage="[getInfoInstallManual()]"
                                                   style="margin-left: 4px; margin-right: 4px;" />
                            </span>
                            <template v-if="isMDMApp">
                                <div class="d-flex flex-column">
                                    <input type="text" value="強制インストール" class="input-text-scv" style="width: 400px" disabled/>
                                </div>
                            </template>
                            <template v-else>
                                <label class="scv-check-label-box">
                                    <input type="radio" :name="'appMgrPermissionAppEditModal_installtype' + myAppMgrPermissionAppEditModalIDNumber" v-model="distributionType" :value="DistributionManual">
                                    <span>任意インストール</span>
                                </label>
                                <label class="scv-check-label-box" style="margin-left: 24px;">
                                    <input type="radio" :name="'appMgrPermissionAppEditModal_installtype' + myAppMgrPermissionAppEditModalIDNumber" v-model="distributionType" :value="DistributionAuto">
                                    <span>プレインストール</span>
                                </label>
                                <label class="scv-check-label-box" style="margin-left: 24px;">
                                    <input type="radio" :name="'appMgrPermissionAppEditModal_installtype' + myAppMgrPermissionAppEditModalIDNumber" v-model="distributionType" :value="DistributionForce">
                                    <span>強制インストール</span>
                                </label>
                            </template>
                        </div>
                        <div class="setting-box">
                            <span class="box-item-title-left">
                                自動アップデート種別：
                                <InformationManual :arMessage="[getInfoupdateManual()]"
                                                   style="margin-left: 4px; margin-right: 4px;" />
                            </span>
                            <label class="scv-check-label-box">
                                <input type="radio" :name="'appMgrPermissionAppEditModal_autoupdate' + myAppMgrPermissionAppEditModalIDNumber" v-model="updateType" :value="UpdateTypeDefault">
                                <span>標準アップデート</span>
                            </label>
                            <label class="scv-check-label-box" style="margin-left: 24px;">
                                <input type="radio" :name="'appMgrPermissionAppEditModal_autoupdate' + myAppMgrPermissionAppEditModalIDNumber" v-model="updateType" :value="UpdateTypePostponed">
                                <span>遅延アップデート</span>
                            </label>
                            <label class="scv-check-label-box" style="margin-left: 24px;">
                                <input type="radio" :name="'appMgrPermissionAppEditModal_autoupdate' + myAppMgrPermissionAppEditModalIDNumber" v-model="updateType" :value="UpdateTypeHighPriority">
                                <span>即時アップデート</span>
                            </label>
                        </div>
                        <div class="setting-box">
                            <span class="box-item-title-left">アクセス権限の許可設定：</span>

                            <div class="d-flex flex-column">
                                <MaskInput convertType="text"
                                           v-bind:value="[('' != basicInfo.packageName) ? converter.GetPermissionSettingListText(converter.ConvertStringToPermissionType(defaultPermission), permmsionGrants) : '']"
                                           class="input-text-scv"
                                           style="width: 400px"
                                           disabled />
                            </div>
                            <template v-if="!isMDMApp">
                                <button type="button"
                                        class="btn-scv-bgcolor btn-setting-size"
                                        @click="onPermissionProperties"
                                        v-bind:disabled="'' == basicInfo.packageName"
                                        style="margin-left: 8px;">
                                    設定
                                </button>
                            </template>
                        </div>
                        <div class="setting-box">
                            <span class="box-item-title-left">アプリケーション管理設定：</span>
                            <div class="d-flex flex-column">
                                <MaskInput convertType="text"
                                           class="input-text-scv"
                                           v-bind:value="[('' != basicInfo.packageName) ? converter.GetMgrConfigurationText(mgrConfigrations) : '']"
                                           style="width: 400px"
                                           disabled />
                            </div>
                            <template v-if="!isMDMApp">
                                <button type="button"
                                        class="btn-scv-bgcolor btn-setting-size"
                                        @click="onManagedProperties"
                                        v-bind:disabled="'' == basicInfo.packageName"
                                        style="margin-left: 8px;">設定</button>
                            </template>
                        </div>
                        <template v-if="!isMDMAppForUI">
                            <div class="scv-separator-bg" style="margin-top: 16px;"></div>
                            <div class="setting-box">
                                <div :class="[{ 'disabled-scv-opacity': isMDMApp }]">
                                    <label class="scv-check-label-box">
                                        <input type="checkbox" v-model="chkDisabled" v-bind:disabled="isMDMApp">
                                        <span>一時的に利用を停止する</span>
                                    </label>
                                </div>
                                <InformationManual :arMessage="['<div>アプリケーションの起動ができなくなります。<br />利用を停止しても、アプリケーションのデータは端末から削除されません。</div>']"
                                                   style="margin-left: 4px;" />
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" @click="onOK" v-bind:disabled="'' == basicInfo.packageName">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal" style="margin-left: 40px;">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Google Play -->
    <AndroidGooglePlayDialog ref="androidGooglePlayDialog"
                             @onOk="onGooglePlaySelected"
                             :idName="idName"
                             :getURLFunction="getURLFunction"
                             :getAppFunction="getAppFunction"
                             :blackPackageList="blackPackageList"
                             :whitePackageList="whitePackageList" 
                             :isBlackConfigList="false"/>
    <!-- アクセス権限 -->
    <AppMgrAccessAuthorityModal ref="accessModal"
                                :prefixID="myAppMgrPermissionAppEditModalIDNumber"
                                :list="applicationPermissions"
                                :listSetting="permmsionGrants"
                                :defaultPermission="defaultPermission"
                                @onOK="onOKPermissionProperties" />
    <!-- 管理設定 -->
    <AppMgrManagedConfigurationModal ref="mgrModal"
                                     :list="managedPropertys"
                                     :listSetting="mgrConfigrations"
                                     @onOK="onOKManagedConfiguration" />
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import $ from "jquery";
    import { cloneDeep } from 'lodash';
    import { AndroidAppMgrApplicationSetting, AndroidAppMgrApplicationBasicJsonExtend } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting';
    import { ApplicationPolicyConverter, ApplicationPolicyDef } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter'
    import MaskInput from '@/components/Input/MaskInput.vue';
    import AppMgrAccessAuthorityModal from '@/components/Mobile/AndroidAppDist/AppMgrAccessAuthorityModal.vue';
    import AppMgrManagedConfigurationModal from '@/components/Mobile/AndroidAppDist/AppMgrManagedConfigurationModal.vue';
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import { MessageText } from '@/models/Message/MessageText';
    import { LoadingUtil } from 'lib-vue-v2/util';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    // for AndroidGooglePlayDialog
    import AndroidGooglePlayDialog from '@/views/Mobile/Popup/AndroidGooglePlayDialog.vue';
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { AndroidApplicationWrapper } from '@/models/Mobile/Android/AndroidApplicationWrapper'
    import { PacketDefine } from '@/models/PacketDefine';
    import InformationManual from '@/components/InformationManual.vue';
    import { AndroidAppDistDefinition } from "@/components/Mobile/AndroidAppDist/AndroidAppDistDefinition";
    @Options({
        props: {
            idName: { type: String, required: true },   // モーダル内のID関連の名前
            addMode: { type: Boolean, required: true }, // 表示モード
            getURLFunction: { type: Function },     // Google Play を iframe に埋め込むためのURL取得関数
            getAppFunction: { type: Function },      // アプリケーション詳細情報の取得関数
            blackPackageList: { type: Object, default: undefined }, // 現在登録済みのアプリケーション<ブラックリスト>( Set<string> )
            whitePackageList: { type: Object, default: undefined },  // 現在登録済みのアプリケーション<ホワイトリスト>( Set<string> )
            isMDMAppForUI: { type: Boolean, default: false }, // 「SKYSEA MDMアプリを追加」ボタンからMDMアプリを追加かどうか
            mdmAppPackageName: { type: String, default: "" }, // MDMアプリのパッケージ名
            version: { type: Number, default: 0 }, // 管理機のバージョン
        },
        components: {
            MaskInput,
            AndroidGooglePlayDialog,
            AppMgrAccessAuthorityModal,
            AppMgrManagedConfigurationModal,
            InformationManual,
        },
        computed: {
        },
        emits: [
            /*
             * OKボタン押下
             * @param[in] AndroidAppMgrApplicationSetting : 設定内容
             * @param[in] boolean : true:追加 false:編集
             */
            'onOK'
        ],
    })

    export default class AppMgrPermissionAppEditModal extends Vue {
        // Mode
        private addMode!: boolean;
        
        // 現在登録済みのアプリケーション（重複チェック用）
        private blackPackageList!: Set<string> | undefined;
        private whitePackageList!: Set<string> | undefined;

        // 発行済みID
        private static AppMgrPermissionAppEditModalIDNumber = 0;
        // 自身のID
        private myAppMgrPermissionAppEditModalIDNumber = 0;

        // props
        private getAppFunction!: any;
        private readonly mdmAppPackageName!: string;   // MDMアプリパッケージ名
        private readonly version!: number;   // 管理機のバージョン


        // メンバ変数(UIデータ)
        private basicInfo = new AndroidAppMgrApplicationBasicJsonExtend();    // ポリシーに入らないデータ(アプリ名、パッケージ名、アイコン、提供元、カテゴリなど)
        private updateType: ApplicationPolicyDef.UPDATE_TYPE = ApplicationPolicyDef.UPDATE_TYPE.Default;    // 自動更新
        private distributionType: ApplicationPolicyDef.DISTRIBUTION_TYPE = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteManual; // 任意インストール
        private chkDisabled = false;    // 一時利用停止

        // アクセス権限情報（permmsionGrantsとapplicationPermissionsは長さが同じなこと）
        private permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();    // 設定データ（ラジオの状態）
        private applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();   // 表示データ（名前とか説明とか）
        private defaultPermission: ApplicationPolicyDef.PERMISSION_GRANT_TYPE = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;  // 既定の権限設定

        // 管理設定
        private mgrConfigrations: { [key: string]: any } = {}; // 設定データ(連想配列)
        private managedPropertys = new Array<schema.AMAPI_ManagedProperty>();  // 表示データ（名前とか説明とか）

        // 定数(グローバル変数はなぜかHTMLにbindできない)
        private readonly UpdateTypeDefault = ApplicationPolicyDef.UPDATE_TYPE.Default;
        private readonly UpdateTypePostponed = ApplicationPolicyDef.UPDATE_TYPE.Postponed;
        private readonly UpdateTypeHighPriority = ApplicationPolicyDef.UPDATE_TYPE.HighPriority;


        private readonly DistributionManual = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteManual;
        private readonly DistributionAuto = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteAuto;
        private readonly DistributionForce = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteForce;

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        // 画面モード
        private bAddMode = true;

        private isMDMApp = false;                   // SKYSEAMDMアプリかどうか
        private readonly isMDMAppForUI!: boolean;   // 「SKYSEA MDMアプリを追加」ボタンからMDMアプリを追加かどうか

        // 定義値
        private readonly defVersion = new PacketDefine();


        /**
         * @brief   created
         */
        public created(): void {
            // 発行済みIDをインクリメントして他のメッセージダイアログとIDが重複しないようにする
            AppMgrPermissionAppEditModal.AppMgrPermissionAppEditModalIDNumber += 1;
            this.myAppMgrPermissionAppEditModalIDNumber = AppMgrPermissionAppEditModal.AppMgrPermissionAppEditModalIDNumber;
        }

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrPermissionAppEditModal').attr('id', "appMgrPermissionAppEditModal" + this.myAppMgrPermissionAppEditModalIDNumber);

            // 画面が開いた時の処理
            const el = document.getElementById(this.GetID());
            if(null != el) {
                el.addEventListener('hidden.bs.modal', () => {
                    this.bAddMode = true;
                });
                el.addEventListener('show.bs.modal', () => {
                    // Google Playストアアプリを追加
                    if (this.bAddMode && !this.isMDMAppForUI) {
                        this.basicInfo = new AndroidAppMgrApplicationBasicJsonExtend();
                        this.updateType = ApplicationPolicyDef.UPDATE_TYPE.Default
                        this.distributionType = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteManual
                        this.chkDisabled = false;
                        this.permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();
                        this.applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();
                        this.mgrConfigrations = {};
                        this.managedPropertys = new Array<schema.AMAPI_ManagedProperty>();
                        this.defaultPermission = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;
                        this.isMDMApp = false;
                    }                    
                });
            }

            const refObj: any = this.$refs;
            // モーダル各種を閉じたときの対応（これをしないと、画面閉じたときに親画面のスクロールが復活する）
            const  elMgrModal = document.getElementById(refObj.mgrModal.GetID());
            if(null != elMgrModal) {
                elMgrModal.addEventListener('hidden.bs.modal', function (e) {
                    $('body').addClass('modal-open');
                })
            }
            const  elAppMgrAccessAuthorityModal = document.getElementById("appMgrAccessAuthorityModal" + this.myAppMgrPermissionAppEditModalIDNumber);
            if(null != elAppMgrAccessAuthorityModal) {
                elAppMgrAccessAuthorityModal.addEventListener('hidden.bs.modal', function (e) {
                    $('body').addClass('modal-open');
                })
            }
            const  elAndroidGooglePlayDialog = document.getElementById(refObj.androidGooglePlayDialog.GetID());
            if(null != elAndroidGooglePlayDialog) {
                elAndroidGooglePlayDialog.addEventListener('hidden.bs.modal', function (e) {
                    $('body').addClass('modal-open');
                })
            }            
        }

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return 'appMgrPermissionAppEditModal' + this.myAppMgrPermissionAppEditModalIDNumber;
        }

        /**
         * @brief   編集データを作成します
         * @return  false: 作成失敗（この画面を呼び出さないこと）
         */
        public async SetEditSeting(setting: AndroidAppMgrApplicationSetting): Promise<boolean> {
            // UIデータに反映
            this.basicInfo.packageName = this.converter.GetPackageName(setting.policyJson);

            this.distributionType = this.converter.GetDistributionType(setting.policyJson);
            this.updateType = this.converter.GetUpdateType(setting.policyJson);
            this.chkDisabled = this.converter.GetDisabled(setting.policyJson);

            // 細かい詳細情報を取得
            LoadingUtil.Start();
            const res = await this.getAppFunction(this.basicInfo.packageName);
            LoadingUtil.Stop();

            if (res.status == 200) {
                const application: schema.AMAPI_Application = Object.assign(new schema.AMAPI_Application(), res.data.appData);
                // MDMアプリかどうか
                this.isMDMApp = res.data.isMDMApp;
               
                // アプリ名
                this.basicInfo.appName = application.title ?? "＜不明＞";

                // アクセス権限
                if (undefined != application.permissions) {
                    this.applicationPermissions = application.permissions;
                }
                else {
                    this.applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();
                }

                if (undefined != setting.policyJson.permissionGrants || null != setting.policyJson.permissionGrants) {
                    this.permmsionGrants = setting.policyJson.permissionGrants;
                }
                else {
                    this.permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();
                }

                // 既定のアクセス権限
                this.defaultPermission = this.converter.ConvertStringToPermissionType(setting.policyJson.defaultPermissionPolicy);

                // 管理設定
                if (undefined != application.managedProperties) {
                    this.managedPropertys = application.managedProperties;
                }
                else {
                    this.managedPropertys = new Array<schema.AMAPI_ManagedProperty>();
                }

                if (undefined != setting.policyJson.managedConfiguration || null != setting.policyJson.managedConfiguration) {
                    this.mgrConfigrations = setting.policyJson.managedConfiguration;
                }
                else {
                    this.mgrConfigrations = {};
                }

                // アイコン
                if (undefined != application.smallIconUrl || null != application.smallIconUrl) {
                    this.basicInfo.iconUrl = application.smallIconUrl;
                }
                else {
                    this.basicInfo.iconUrl = "";
                }

                // 提供元
                if (undefined != application.author || null != application.author) {
                    this.basicInfo.author = application.author;
                }
                else {
                    this.basicInfo.author = "";
                }

                // カテゴリ
                if (undefined != application.category || null != application.category) {
                    this.basicInfo.category = application.category;
                }
                else {
                    this.basicInfo.category = "";
                }

                // アプリケーション種別
                this.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY;

                // 更新日時を更新
                this.basicInfo.updateTimeUtc = new Date();
            }
            else if (res.status == 401) {
                // none(session timeout)
                return false;
            }
            else {
                MessageUtil.MessageBox(MessageText.dataGetErrorMessage, null, null, MessageUtil.MB_ICON_ERROR);
                return false;
            }

            this.bAddMode = false;  // 編集モードに切り替え

            return true;
        }

        /**
         * @brief	MDMアプリを設定
         * @return  false: 作成失敗（この画面を呼び出さないこと）
         */
        public async SetMDMApp(): Promise<boolean> {
            LoadingUtil.Start();
            const res = await this.getAppFunction(this.mdmAppPackageName);
            LoadingUtil.Stop();

            if (res.status == 200) {
                // MDMアプリの情報をUIに設定
                this.onGooglePlaySelected(this.mdmAppPackageName, res.data);
            }
            else if (res.status == 401) {
                // none(session timeout)
                return false;
            }
            else {
                MessageUtil.MessageBox(MessageText.dataGetErrorMessage, null, null, MessageUtil.MB_ICON_ERROR);
                return false;
            }

            return true;
        }

        /**
         * @brief	OKボタン
         */
        private onOK(): void {
            if ("" == this.basicInfo.packageName) {
                // ありえない
                return;
            }
            if(this.addMode){
                if (undefined !== this.blackPackageList) {
                    if (this.blackPackageList.has(this.basicInfo.packageName.toLowerCase())) {
                        MessageUtil.MessageBox("すでに同じアプリケーションが登録されています。", null, null, MessageUtil.MB_ICON_WARNING);
                        return;
                    }
                }
                if (undefined != this.whitePackageList) {
                    if (this.whitePackageList.has(this.basicInfo.packageName.toLowerCase())) {
                        MessageUtil.MessageBox("すでに同じアプリケーションが登録されています。", null, null, MessageUtil.MB_ICON_WARNING);
                        return;
                    }
                }
            }

            // UI表示用データクラスに格納する
            var uiData = new AndroidAppMgrApplicationSetting();
            uiData.basicInfo = this.basicInfo;
            uiData.policyJson.packageName = this.basicInfo.packageName;

            this.converter.SetDistributionType(uiData.policyJson, this.distributionType);
            this.converter.SetUpdateType(uiData.policyJson, this.updateType);
            this.converter.SetDisabled(uiData.policyJson, this.chkDisabled);
            uiData.policyJson.permissionGrants = this.permmsionGrants;
            uiData.policyJson.managedConfiguration = this.mgrConfigrations;

            // 既定のアクセス権限
            uiData.policyJson.defaultPermissionPolicy = cloneDeep(this.defaultPermission as string);

            // 親コンポーネント通知
            this.$emit('onOK', cloneDeep(uiData), this.bAddMode);

            // 画面を閉じる
            BootstrapUtil.hideModal(this.GetID());
        }

        /**
         * @brief	Playストアから選択ボタン
         */
        private onGooglePlayButton(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            BootstrapUtil.showModal(refObj.androidGooglePlayDialog.GetID());
        }

        /**
         * Google Play 選択ダイアログの [OK]ハンドラ
         */
        private onGooglePlaySelected(packageName: string, wrap: AndroidApplicationWrapper): void {
            // MDM アプリかどうか
            this.isMDMApp = wrap.isMDMApp;

            // 過去バージョンでMDMアプリは追加できない
            if (this.version < this.defVersion.REV_19_1_0 && this.isMDMApp) {
                this.isMDMApp = false;
                
                MessageUtil.MessageBox(
                    "「SKYSEA MDM」アプリは、Ver.19.1以降の管理機で選択できます。"	//${Ignore4Mec} SKYMEC2025時点でMDM未対応のため
                    , null
                    , null
                    , MessageUtil.MB_ICON_WARNING
                );
                return;
            }


            this.basicInfo.appName = String(wrap.appData.title);
            this.basicInfo.packageName = packageName;

            // アクセス権限の設定をデフォルトで作成
            if (undefined != wrap.appData.permissions) {
                this.applicationPermissions = wrap.appData.permissions;
                this.permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();
            }
            else {
                this.applicationPermissions = new Array<schema.AMAPI_ApplicationPermission>();
                this.permmsionGrants = new Array<schema.AMAPI_PermissionGrant>();
            }

            // 既定のアクセス権限
            this.defaultPermission = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;

            // 管理設定は必ず初期化
            this.mgrConfigrations = {};
            if (undefined != wrap.appData.managedProperties) {
                this.managedPropertys = wrap.appData.managedProperties;
            }
            else {
                this.managedPropertys = new Array<schema.AMAPI_ManagedProperty>();
            }

            // アイコン
            if (undefined != wrap.appData.smallIconUrl || null != wrap.appData.smallIconUrl) {
                this.basicInfo.iconUrl = wrap.appData.smallIconUrl;
            }
            else {
                this.basicInfo.iconUrl = "";
            }

            // 提供元
            if (undefined != wrap.appData.author || null != wrap.appData.author) {
                this.basicInfo.author = wrap.appData.author;
            }
            else {
                this.basicInfo.author = "";
            }

            // カテゴリ
            if (undefined != wrap.appData.category || null != wrap.appData.category) {
                this.basicInfo.category = wrap.appData.category;
            }
            else {
                this.basicInfo.category = "";
            }

            // アプリケーション種別
            this.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY;

            // 更新日時を更新
            this.basicInfo.updateTimeUtc = new Date();

            if (this.isMDMApp) {
                // 「SKYSEA MDMアプリを追加」ボタンからMDMアプリを追加した場合はメッセージなし
                if (!this.isMDMAppForUI) {
                    MessageUtil.MessageBox(
                        "「SKYSEA MDM」アプリは、「自動アップデート種別」のみ設定できます。"
                        , null
                        , null
                        , MessageUtil.MB_ICON_INFO
                    );
                }

                // MDMアプリの場合は固定で下記設定を適用
                this.chkDisabled = false;
                this.distributionType = ApplicationPolicyDef.DISTRIBUTION_TYPE.WhiteForce;
                this.updateType = ApplicationPolicyDef.UPDATE_TYPE.Default;
            }
        }

        /**
         * アクセス権限押下
         */
        private onPermissionProperties(): void {
            BootstrapUtil.showModal("appMgrAccessAuthorityModal" + this.myAppMgrPermissionAppEditModalIDNumber);
        }

        /**
         * アクセス権限でOKが押下
         */
        private onOKPermissionProperties(settings: Array<schema.AMAPI_PermissionGrant>, defaultPermission: ApplicationPolicyDef.PERMISSION_GRANT_TYPE): void {
            this.permmsionGrants = settings;
            this.defaultPermission = defaultPermission;
        }

        /**
         * 管理設定押下
         */
        private onManagedProperties(): void {
            if (0 == this.managedPropertys.length) {
                MessageUtil.MessageBox("選択したアプリケーションは設定項目がありません。", null, null, MessageUtil.MB_ICON_INFO);
                return;
            }

            const refObj: any = this.$refs;
            BootstrapUtil.showModal(refObj.mgrModal.GetID());
        }

        /**
         * アクセス権限でOKが押下
         */
        private onOKManagedConfiguration(settings: { [key: string]: any }): void {
            this.mgrConfigrations = settings;
        }

        /**
         * @brief	アプリケーション設定の補足マニュアルの内容を作成
         */
        private getInfoAppSeting(): string {
            let strRet = "";
            strRet += '<div>';
            strRet += '「アクセス権限の許可設定」「アプリケーション管理設定」は、端末のOSバージョン、<br />' +
                'アプリケーション、アクセス権限の種類等により、設定通りに動作しない場合があります。<br />' +
                '設定適用後に端末で動作を確認してください。';
            strRet += '</div>';

            return strRet;
        }

        /**
         * @brief	アップデート補足マニュアルの内容を作成
         */
        private getInfoupdateManual(): string {
            let strRet = "";
            strRet += '<div class="d-flex flex-column">';
            strRet += 'MDMで管理されているAndroid端末は、アプリケーションが自動的にアップデートされます。<br />適用する「自動アップデート種別」によって、自動アップデートの条件・タイミングが異なります。';
            strRet += '<div class="tooltip-manual-body-scv-padding-height-16"></div>';

            // テーブル
            strRet += '<div class="table-scv-out-border">'  // 外枠
            strRet += '<div class="d-flex flex-column table-div-scv">'

            // テーブル（ヘッダー）
            strRet += '<div class="thead-div-scv">'
            strRet += '<div class="d-flex flex-row tr-div-scv">'
            strRet += '<div class="th-div-scv scv-info-manual-setting-mobile-app-distribution-auto-update-type">自動アップデート種別</div>'
            strRet += '<div class="th-div-scv scv-info-manual-setting-mobile-app-distribution-auto-update-timing">自動アップデートの条件・タイミング</div>'
            strRet += '</div>'; // tr-div-scv
            strRet += '</div>'; // thead-div-scv
            // テーブル（ヘッダー）終わり

            // テーブル（ボディ）
            strRet += '<div class="tbody-div-scv">'

            // 標準アップデート
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-type">標準アップデート</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-timing">Android標準のアップデート設定です。<br />端末の設定に従って、アプリケーションをアップデートします。</div>'
            strRet += '</div>'; // tr-div-scv
            // 標準アップデート終わり

            // 遅延アップデート
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-type">遅延アップデート</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-timing">新規インストール／前回のアップデートから90日間は自動アップデートしません。<br />90日経過後、新しいバージョンが存在する場合は、端末が条件を満たす（※）とアプリケーションをアップデートします。</div>'
            strRet += '</div>'; // tr-div-scv
            // 遅延アップデート終わり

            // 即時アップデート
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-type">即時アップデート</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-auto-update-timing">新しいバージョンが公開されると、その情報がすぐに端末へ通知され、無条件でアプリケーションをアップデートします。</div>'
            strRet += '</div>'; // tr-div-scv
            // 即時アップデート終わり


            strRet += '</div>'; // tbody-div-scv
            // テーブル（ボディ）終わり

            strRet += '</div>'; // table-div-scv
            strRet += '</div>'; // table-scv-out-border // 外枠
            // テーブル終わり

            strRet += '<div class="tooltip-manual-body-scv-padding-height-4"></div>';
            strRet += '<div class="scv-annotation-text">※以下のすべての条件を満たす必要があります。<br />・端末が使用されていない<br />・端末が従量課金ではないネットワーク（Wi-Fiネットワーク等）に接続している<br />・端末が充電中</div>';
            strRet += '</div>'; //flex-column
            return strRet;
        }


        /**
         * @brief	インストール補足マニュアルの内容を作成
         */
        private getInfoInstallManual(): string {
            let strRet = "";
            strRet += '<div class="d-flex flex-column">';
            strRet += '各インストール種別の動作は以下のとおりです。';
            strRet += '<div class="tooltip-manual-body-scv-padding-height-16"></div>';

            // テーブル
            strRet += '<div class="table-scv-out-border">'  // 外枠
            strRet += '<div class="d-flex flex-column table-div-scv">'

            // テーブル（ヘッダー）
            strRet += '<div class="thead-div-scv">'
            strRet += '<div class="d-flex flex-row tr-div-scv">'
            strRet += '<div class="th-div-scv scv-info-manual-setting-mobile-app-distribution-install-type">インストール種別</div>'
            strRet += '<div class="th-div-scv scv-info-manual-setting-mobile-app-distribution-install-method">インストール方法</div>'
            strRet += '<div class="th-div-scv scv-info-manual-setting-mobile-app-distribution-uninstall">端末利用者によるアンインストール</div>'
            strRet += '</div>'; // tr-div-scv
            strRet += '</div>'; // thead-div-scv
            // テーブル（ヘッダー）終わりｓ

            // テーブル（ボディ）
            strRet += '<div class="tbody-div-scv">'

            // インストール種別
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-type">任意インストール</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-method">端末利用者がGoogle Playストアから手動でインストール</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-uninstall">可</div>'
            strRet += '</div>'; // tr-div-scv
            // インストール種別

            // プレインストール
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-type">プレインストール</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-method">端末に自動でインストール（※）</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-uninstall">可</div>'
            strRet += '</div>'; // tr-div-scv
            // プレインストール

            // 強制インストール
            strRet += '<div class="tr-div-scv">'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-type">強制インストール</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-install-method">端末に自動でインストール</div>'
            strRet += '<div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell scv-info-manual-setting-mobile-app-distribution-uninstall">不可</div>'
            strRet += '</div>'; // tr-div-scv
            // 強制インストール終わり


            strRet += '</div>'; // tbody-div-scv
            // テーブル（ボディ）終わり

            strRet += '</div>'; // table-div-scv
            strRet += '</div>'; // table-scv-out-border // 外枠
            // テーブル終わり

            strRet += '<div class="tooltip-manual-body-scv-padding-height-4"></div>';
            strRet += '<div class="scv-annotation-text">※本アプリケーションをアンインストールしたことがある端末は、自動でインストールされません。<br />' +
                '　端末利用者がGoogle Playストアから手動でインストールすることは可能です。';
            strRet += '</div>'; //flex-column
            return strRet;
        }
    }
</script>

<style scoped>
    /* テキストタイトル(左寄せ) */
    .box-item-title-left {
        display: flex;
        justify-content: start;
        align-items: center;
        height: 32px;
        width: 200px;
    }

    /* 設定エリア */
    .setting-area {
        margin: 16px 16px 24px 0px;
    }

    /* 設定項目 */
    .setting-box {
        display: flex;
        align-items: center;
        flex-direction: row;
    }

</style>

<style>
    /* セル */
    .scv-info-manual-setting-mobile-app-distribution-cell {
        padding-top: 8px !important;
        padding-bottom: 8px !important;
    }

    /* 補足マニュアルの自動アップデート種別 */
    .scv-info-manual-setting-mobile-app-distribution-auto-update-type {
        min-width: 156px;
    }

    /* 補足マニュアルの自動アップデートの条件・タイミング */
    .scv-info-manual-setting-mobile-app-distribution-auto-update-timing {
        min-width: 477px;
        max-width: 477px;
    }

    /* 補足マニュアルのインストール種別 */
    .scv-info-manual-setting-mobile-app-distribution-install-type {
        min-width: 130px
    }

    /* 補足マニュアルのインストール方法 */
    .scv-info-manual-setting-mobile-app-distribution-install-method {
        min-width: 256px;
    }

    /* 補足マニュアルの端末利用者によるアンインストール */
    .scv-info-manual-setting-mobile-app-distribution-uninstall {
        min-width: 250px;
    }
</style>
